'use client'

import { Box } from '@mui/material'
import { SvgAsset } from '~/components/SvgAsset'

type Props = {
  hide: boolean
}

export const Splash = ({ hide }: Props) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        opacity: 1,
        animation: hide ? 'fadeOut 200ms cubic-bezier(0.3, 0.3, 1, 0.3) forwards' : undefined,
        '@keyframes fadeOut': {
          from: { opacity: 1 },
          to: { opacity: 0 },
        },
      }}
    >
      <SvgAsset
        asset='logo'
        sx={{
          width: 64,
          height: 64,
          animation: 'splashZoom 800ms cubic-bezier(0.3, 0.3, 1, 0.3) forwards',
          '@keyframes splashZoom': {
            from: { transform: 'scale(1)' },
            to: { transform: 'scale(2)' },
          },
        }}
      />
    </Box>
  )
}
